import { useSelector } from 'react-redux';
import * as TransactionalService from 'services/transactional';
import { useNavigate } from 'react-router-dom';
import { urls } from 'services/_url';

export const useTransactionalService = () => {
  const { token } = useSelector((store) => store.user_data);
  const history = useNavigate();

  const fetchTransactionalById = async (id, options = {}) => {
    const { error, payload } = await TransactionalService.readById(id, {
      ...options,
      token
    });
    if (error) {
      return { transactional: {} };
    }

    return { transactional: payload };
  };

  const fetchTransactionals = async (options = {}) => {
    const { error, payload } = await TransactionalService.read({ ...options, token });
    if (error) {
      return { transactionals: [], size: 0 };
    }

    const {
      data: transactionals,
      meta: { size }
    } = payload;
    return { transactionals, size };
  };

  const creationOptions = [
    { icon_name: 'note', text: 'Plain text', onClick: () => history('/editor/transactional') },
    {
      icon_name: 'colors',
      text: 'Template builder',
      onClick: () => (window.location.href = `${urls.editor}/transactionals?t=${token}`)
    }
  ];

  return { fetchTransactionalById, fetchTransactionals, creationOptions };
};
